<template>
  <div class="synatec-tab">
    <div class="synatec-section">
      <div class="section-header">
        <h3 class="section-title">{{ $t("globals.synatec_orders") }}</h3>
        <div class="header-actions">
          <b-dropdown
            v-if="getUserBrandPermissions.synatec_order_create"
            size="sm"
            right
            class="modern-dropdown"
            :text="$t('globals.create_synatec_order')"
          >
            <b-dropdown-item @click="showMakeSynatecOrderModalAuto = true">
              {{ $t("globals.create_synatec_order") }} - Auto
            </b-dropdown-item>
            <b-dropdown-item @click="showMakeSynatecOrderModalManual = true">
              {{ $t("globals.create_synatec_order") }} - Manual
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>

      <div class="filters-section">
        <div class="search-container">
          <input
            type="text"
            v-model="filter"
            :placeholder="$t('globals.type_to_search')"
            class="search-input"
          />
        </div>
        <button
          v-if="filter"
          class="search-btn clear-btn"
          @click="filter = ''"
        >
          {{ $t("globals.clear") }}
        </button>
      </div>

      <div class="table-wrapper">
        <table class="modern-table">
          <thead>
            <tr>
              <th @click="sortTable('id')" class="sortable">
                ID
                <span class="sort-icon" v-if="sortBy === 'id'">
                  {{ sortDesc ? '▼' : '▲' }}
                </span>
              </th>
              <th>{{ $t("globals.agent") }}</th>
              <th @click="sortTable('status')" class="sortable">
                {{ $t("globals.status") }}
                <span class="sort-icon" v-if="sortBy === 'status'">
                  {{ sortDesc ? '▼' : '▲' }}
                </span>
              </th>
              <th @click="sortTable('created_at')" class="sortable">
                {{ $t("globals.created_at") }}
                <span class="sort-icon" v-if="sortBy === 'created_at'">
                  {{ sortDesc ? '▼' : '▲' }}
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in paginatedItems"
              :key="item.id"
              @click="goToSynatecOrder(item)"
            >
              <td>{{ item.id }}</td>
              <td>{{ item.agent ? item.agent.full_name : '' }}</td>
              <td>
                <span class="status-badge" :class="'status-' + item.status.toLowerCase()">
                  {{ $t("globals." + item.status) }}
                </span>
              </td>
              <td :title="item.created_at">
                {{ item.created_at ? item.created_at.substring(0, 10) : '' }}
              </td>
            </tr>
            <tr v-if="!order.synatec_orders || order.synatec_orders.length === 0">
              <td colspan="4" class="empty-state-cell">No synatec orders found</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div v-if="order.synatec_orders && order.synatec_orders.length > 0" class="pagination-section">
        <div class="controls-left">
          <span class="summary-label">{{ $t("globals.per_page") }}:</span>
          <select v-model="perPage" class="per-page-select">
            <option :value="10">10</option>
            <option :value="20">20</option>
            <option :value="30">30</option>
          </select>
          <span class="summary-label">
            {{ $t("globals.showing") }} {{ ((currentPage - 1) * perPage) + 1 }}-{{ Math.min(currentPage * perPage, filteredItems.length) }}
          </span>
        </div>
        <div class="pagination-controls">
          <button
            class="page-btn"
            @click="currentPage--"
            :disabled="currentPage === 1"
          >
            &lt;
          </button>
          <button
            class="page-btn"
            @click="currentPage++"
            :disabled="currentPage === totalPages"
          >
            &gt;
          </button>
        </div>
      </div>
    </div>

    <ulu-synatec-modal-auto
      :show="showMakeSynatecOrderModalAuto"
      :close="closeModals"
      :order="order"
      :prefillData="prefillData"
    />
    <ulu-synatec-modal-manual
      :show="showMakeSynatecOrderModalManual"
      :close="closeModals"
      :order="order"
      :prefillData="prefillData"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  components: {
    "ulu-synatec-modal-auto": () =>
      import("@/components/orders/order/order_synatec_tab/SynatecModalAuto"),
    "ulu-synatec-modal-manual": () =>
      import("@/components/orders/order/order_synatec_tab/SynatecModalManual")
  },
  props: {
    refreshOrder: Function,
    order: Object,
    
  },
  data() {
    return {
      showMakeSynatecOrderModalAuto: false,
      showMakeSynatecOrderModalManual: false,
      sortBy: "id",
      sortDesc: true,
      filter: "",
      currentPage: 1,
      perPage: 10,

      prefillData: {
          // fleet_print:{
          //   firstName: "Dimitri",
          //   lastName: "Borrius",
          //   email: "info@iceu.nl",
          //   address: "Cuxhavenweg 5 /C",
          //   city: "Groningen",
          //   postalCode: "9723 JK",
          //   country: "NL"
          // },
          ulu_hq:{
            firstName: "Field",
            lastName: "Tracker",
            email: "info@ulu.io",
            address: "Boeingavenue 241",
            city: "Schiphol-Rijk",
            postalCode: "1119 PD",
            country: "NL"
          },
          mobi_install:{
            firstName: "Mobi",
            lastName: "Install",
            email: "info@mobi-install.nl",
            address: "Zuidbaan 548D",
            city: "Moordrecht",
            postalCode: "2841 MD",
            country: "NL"
        }
      }
    };
  },
  methods: {
    ...mapMutations(["setShowLoadingModal"]),
    goToSynatecOrder(item) {
      this.$router.push({
        name: "synatecorder",
        params: { id: item.id }
      });
    },
    closeModals() {
      this.showMakeSynatecOrderModalAuto = false;
      this.showMakeSynatecOrderModalManual = false;
      this.refreshOrder();
    },
    sortTable(field) {
      if (this.sortBy === field) {
        this.sortDesc = !this.sortDesc;
      } else {
        this.sortBy = field;
        this.sortDesc = false;
      }
    }
  },
  computed: {
    ...mapGetters(["getUserBrandPermissions"]),
    filteredItems() {
      if (!this.order.synatec_orders || this.order.synatec_orders.length === 0) return [];

      let items = [...this.order.synatec_orders];

      // Apply filter
      if (this.filter && this.filter.trim() !== "") {
        const filterLower = this.filter.toLowerCase();
        items = items.filter(item => {
          return (
            (item.id && item.id.toString().includes(filterLower)) ||
            (item.agent && item.agent.full_name && item.agent.full_name.toLowerCase().includes(filterLower)) ||
            (item.status && item.status.toLowerCase().includes(filterLower)) ||
            (item.created_at && item.created_at.toLowerCase().includes(filterLower))
          );
        });
      }

      // Apply sorting
      items.sort((a, b) => {
        let aVal = a[this.sortBy];
        let bVal = b[this.sortBy];

        // Handle nested properties (like agent.full_name)
        if (this.sortBy === 'agent') {
          aVal = a.agent ? a.agent.full_name : '';
          bVal = b.agent ? b.agent.full_name : '';
        }

        if (aVal === null || aVal === undefined) return 1;
        if (bVal === null || bVal === undefined) return -1;

        if (typeof aVal === 'string') {
          aVal = aVal.toLowerCase();
          bVal = bVal.toLowerCase();
        }

        if (aVal < bVal) return this.sortDesc ? 1 : -1;
        if (aVal > bVal) return this.sortDesc ? -1 : 1;
        return 0;
      });

      return items;
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredItems.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.filteredItems.length / this.perPage);
    }
  },
  watch: {
    filter() {
      this.currentPage = 1;
    }
  }
};
</script>

<style scoped>
.synatec-tab {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.header-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

/* Modern Dropdown Styling */
.modern-dropdown ::v-deep .btn {
  background-color: #5469d4;
  border: none;
  padding: 0.625rem 1.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  border-radius: 6px;
  text-transform: uppercase;
  color: white;
  transition: background-color 0.2s;
}

.modern-dropdown ::v-deep .btn:hover,
.modern-dropdown ::v-deep .btn:focus,
.modern-dropdown ::v-deep .btn:active {
  background-color: #4353b8;
  border: none;
  box-shadow: none;
}

.modern-dropdown ::v-deep .dropdown-menu {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 0.5rem 0;
}

.modern-dropdown ::v-deep .dropdown-item {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  color: #495057;
  transition: background-color 0.2s;
}

.modern-dropdown ::v-deep .dropdown-item:hover {
  background-color: #f8f9fa;
  color: #5469d4;
}

.clear-btn {
  background-color: #ed8936;
  color: white;
  border: none;
}

.clear-btn:hover {
  background-color: #dd6b20;
}
</style>
